import store from '../store/store';
import { getMailboxForwardingConfiguration } from 'owa-forwarding-configuration';
import { getFallbackValueIfNull } from 'owa-options-core';

/**
 * Returns the currently selected option between "Start forwarding" and "Stop
 * forwarding". If the user hasn't made a choice yet, we fall back to the server
 * response and check if AddressString has a value. If not, it means that
 * "Stop fowarding" is the user's current setting.
 */
export default function getChoiceGroupSelection(): 'start' | 'stop' | string {
    const forwardingConfiguration = getMailboxForwardingConfiguration();
    const optionState = store;

    return getFallbackValueIfNull(
        optionState.choiceGroupSelection,
        !!forwardingConfiguration.AddressString ? 'start' : 'stop'
    );
}
